import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "params" }
const _hoisted_2 = { class: "params__wrapper" }

import StatBlock from "@/components/modules/Analytics/Charts/StatBlock.vue";
import DynamicByMonth from "@/components/modules/Analytics/Charts/DynamicByMonth.vue";
import RegionTop from "@/components/modules/Analytics/Charts/RegionTop.vue";
import {CasesSuspendedAnalyticProps} from "@/types/analytics";


export default /*@__PURE__*/_defineComponent({
  __name: 'CasesSuspended',
  props: {
    activeType: {},
    selectedRegion: {},
    selectedDistrict: {},
    analyticData: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(StatBlock, {
        title: "приостановлено дел по п.п.1,2,3 ч.1 ст. 208 УПК РФ",
        value: __props.analyticData.totalData?.suspended_cases?.value,
        percent: __props.analyticData.totalData?.suspended_cases?.percent_to_previous,
        "is-appg": false,
        "is-main": true
      }, null, 8, ["value", "percent"]),
      _createVNode(StatBlock, {
        title: "удельный вес от расследованных",
        value: __props.analyticData.totalData?.suspended_cases_percent?.value,
        percent: __props.analyticData.totalData?.suspended_cases_percent?.percent_to_previous,
        "is-appg": true
      }, null, 8, ["value", "percent"])
    ]),
    _createVNode(DynamicByMonth, {
      "active-type": __props.activeType,
      "selected-region": __props.selectedRegion,
      "selected-district": __props.selectedDistrict,
      dynamic: __props.analyticData.monthlyDynamic
    }, null, 8, ["active-type", "selected-region", "selected-district", "dynamic"]),
    (__props.activeType !== 'region')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(RegionTop, {
            "sort-order": "desc",
            "active-type": __props.activeType,
            "selected-district": __props.selectedDistrict,
            "region-list": __props.analyticData.topDescending
          }, null, 8, ["active-type", "selected-district", "region-list"]),
          _createVNode(RegionTop, {
            "sort-order": "asc",
            "active-type": __props.activeType,
            "selected-district": __props.selectedDistrict,
            "region-list": __props.analyticData.topAscending
          }, null, 8, ["active-type", "selected-district", "region-list"])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})